
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Settings, TenantSettings } from "@shared/core/services/configService";
import { Format } from "@shared/core/helpers/formatHelper";
import store from "../../../shared/core/store";
import { CrudService } from "../../../shared/core/services/crudService";
import MenuShopCart from "../../../shared/components/menuShopCart/menuShopCart.vue";
import VirtualCard from "../virtualCard/virtualCard.vue";


@Component({
  components: {MenuShopCart, VirtualCard},
})
export default class FooterMobile extends Vue {
  @Prop({ default: false }) settings!: TenantSettings;

  private get isHomePage(){
    return this.$route.name === 'index';
  }

  private get hasCartItems() {
    return store.state.cart && store.state.cart.count > 0;
  }

  private get isCartActive() {
    return !this.isHomePage && this.hasCartItems;
  }

  private get isPhoneActive() {
    return !this.isHomePage && !this.hasCartItems;
  }

  private customerQrCode: {
    content: string;
    contentType: string;
    encoding: string;
  } | null = null;
  
  private customerQrCodeTimeout: number | null = null;
  private isQrCodeOpen = false;

  @Watch('isQrCodeOpen')
  onQrCodeOpenChanged(value: boolean) {
    if (value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
  
  private get customerQrCodeImgSrc() {
    if (this.customerQrCode) {
      return `data:${this.customerQrCode.contentType};${
        this.customerQrCode.encoding
      },${this.customerQrCode.content}`;
    }
    return "";
  }

  private get displayAccessCode() {
    return (
      store.state.loggedIn === true
    );
  }

  goToHome() {
    this.$router.push("/");
  }

  getAddressMaps(coords: any) {
    if (Format.IsNull(coords)) {
      return "#";
    }
    const splited = coords.split(",");
    if (splited.length !== 2) {
      return "#";
    }
    return "https://www.google.com/maps/place/" + splited[0] + "," + splited[1];
  }

  getPhone(phone: string | null | undefined){
    if (Format.IsNull(phone)) {
      return "#";
    }
    return `tel:${phone}`;
  }

  private async getCustomerQrCode() {
    this.isQrCodeOpen = true;

    if (this.customerQrCodeTimeout) {
      clearTimeout(this.customerQrCodeTimeout);
      this.customerQrCodeTimeout = null;
    }

    try {
      const url = `${Settings.HostName}/api/publicaccesscontrol/qr`;
      const res = await new CrudService().httpGet(url);

      if (!this.isQrCodeOpen) return;
      if (!res || !res.model) {
        console.error("Error getting customer QR code");
        return;
      }

      const qrData = res.model;

      this.customerQrCode = {
        content: qrData.content,
        contentType: qrData.contentType,
        encoding: qrData.encoding,
      };
    } catch (error) {
      console.error("Error fetching QR code:", error);
    }
  }

  private closeQrCode() {
    this.customerQrCode = null;
    if (this.customerQrCodeTimeout) {
      clearTimeout(this.customerQrCodeTimeout);
      this.customerQrCodeTimeout = null;
    }
    this.isQrCodeOpen = false;
  }

  beforeDestroy() {
    document.body.style.overflow = '';
  }
}
